import React from 'react';
import { motion } from 'framer-motion';
import ServiceCard from '../UI/ServiceCard';

const Services = () => {
  const services = [
    {
      title: 'AI & Agentic Business Implementation',
      description: 'Integrate cutting-edge LLMs and autonomous agents into your business workflows. Transform operations with intelligent automation and decision-making systems.',
      icon: '🤖',
      tags: ['OpenAI', 'Anthropic', 'LangChain', 'RAG'],
      delay: 0.1,
    },
    {
      title: 'Cloud Native Development',
      description: 'Build scalable, resilient applications designed for the cloud. Microservices, containerization, and serverless architectures that grow with your business.',
      icon: '☁️',
      tags: ['Kubernetes', 'Docker', 'Serverless'],
      delay: 0.2,
    },
    {
      title: 'Multi-Cloud Strategy',
      description: 'Expert guidance on AWS, GCP, and Azure adoption. Optimize costs, improve reliability, and avoid vendor lock-in with strategic multi-cloud architecture.',
      icon: '🌐',
      tags: ['AWS', 'GCP', 'Azure', 'Terraform'],
      delay: 0.3,
    },
    {
      title: 'Data & Analytics',
      description: 'Turn raw data into actionable business intelligence. Build data pipelines, implement analytics platforms, and create dashboards that drive decisions.',
      icon: '📊',
      tags: ['BigQuery', 'Snowflake', 'dbt', 'Looker'],
      delay: 0.4,
    },
    {
      title: 'Security & DevOps',
      description: 'SecOps, business continuity, and operational excellence. Implement security best practices, automated testing, and CI/CD pipelines for rapid, safe deployments.',
      icon: '🔒',
      tags: ['GitHub Actions', 'Security', 'Monitoring'],
      delay: 0.5,
    },
    {
      title: 'Product Development',
      description: 'Full-cycle implementation from ideation to launch. Agile methodologies, user research, and iterative development to bring your vision to market.',
      icon: '🚀',
      tags: ['Agile', 'MVP', 'Product Strategy'],
      delay: 0.6,
    },
  ];

  return (
    <section id="services" className="py-24 px-6 bg-cream">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="inline-flex items-center px-4 py-2 bg-white rounded-full mb-6 border border-gray-100"
          >
            <span className="text-sm font-medium text-muted-grey">
              Core Capabilities
            </span>
          </motion.div>

          <h2 className="text-5xl md:text-6xl font-bold text-dark-slate mb-6 tracking-tight">
            Strategic Technology
            <br />
            <span className="text-muted-blue-grey">Leadership</span>
          </h2>

          <p className="text-xl text-muted-grey max-w-3xl mx-auto leading-relaxed">
            End-to-end engineering leadership that bridges business strategy and technical execution.
            From AI implementation to cloud architecture, I deliver results that matter.
          </p>
        </motion.div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 auto-rows-auto">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
